import useDi from '../useDi'

import Token from '@/di/di.token'

export default function useAuthService() {
  const { container } = useDi()
  const service = container.get(Token.AUTH_SERVICE)
  return { service }
}
